import { FormHelperText, Grid, Typography, InputLabel, Button, makeStyles } from '@material-ui/core';
import React, { useEffect, useState, useMemo } from 'react';
import { CustomChip, formatters, PrimaryButton } from '../../../../../Core/Controls';
import '../../../../commonStyle.scss';
import '../../controllerStyle.scss';
import { getJobDetailsById, getJobRequiredDocuments } from '../../../../../Core/Services/InternalUser/ControllerService/jobDetailsService';
import Alert from '@material-ui/lab/Alert';
import InfoIcon from '@material-ui/icons/Info';
import '../../Notes/NotesandSticky.scss';
import { useHistory } from 'react-router-dom';
import StickyNotes from '../../Notes/stickyNotes';
import DialogComp from '../../../../../Core/Dialog/DialogComp';
import FileUploaderButton from '../../../../../Core/Controls/GenericFileUploader';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BuildIcon from '@material-ui/icons/Build';

import JobCustomizeStepper from './JobSteppers';

import CustomerDetails from '../../DetailsModal/customerDetails';
import DepotDetails from '../../DetailsModal/depotDetails';
import VehicleDailyChecks from '../../Vehicles/VehicleDailyChecks/vehicleDailyChecks';
import EditVehicleDailyChecks from '../../Vehicles/VehicleDailyChecks/editVehicleDailyCheck';
import { CustomButtonChip } from '../../../../../Core/Controls/Inputs/DatePicker';
import { useWindowSize } from '../../../../../Core/Hooks/useWindowSize';
import AllStickyNotes from '../../Notes/stickyAllNotes';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import JobAdminstration from './JobSteppers/Administrationstep';

const alertBoxColorCode = {
    AA: 'warning',
    EP: 'warning',
    JP: 'warning',
    AU: 'error',
    JQ: 'error',
    FR: 'error',
    JD: 'error',
    JR: 'error',
    CA: 'success',
    JC: 'success',
    JA: 'success'
};

const useStyles = makeStyles((theme) => ({
    fontValueSizer: {
        fontSize: 14,
        margin: 1,

        color: 'black',
        '@media (max-width: 1024px)': {
            fontSize: 12
        }
    }
}));

const JobDetail = (props) => {
    const classes = useStyles();
    const [ScreenWidth, ScreenHeight] = useWindowSize();
    const history = useHistory();
    const [state, setState] = useState({ showModal: false, refresherFlag: null, selectedInspection: null });
    const [jobDetails, setJobDetails] = useState(props.jobDetails);

    const location = useLocation();

    const { list = [], documents = [] } = props.jobDocument || {};

    const { listWithDocs, unmatchedDocs } = useMemo(() => {
        const listWithDocs = list.map((item) => {
            const matchingDoc = documents.find(
                (d) => (d.scheduleID && d.scheduleID === item.scheduleID) || (d.docName && d.docName === item.docName)
            );
            return { item, matchingDoc };
        });

        const unmatchedDocs = documents.filter(
            (d) => !list.some((item) => (d.scheduleID && d.scheduleID === item.scheduleID) || (d.docName && d.docName === item.docName))
        );

        return { listWithDocs, unmatchedDocs };
    }, [list, documents]);

    useEffect(() => {
        try {
            if (location?.previousPath) {
                localStorage.setItem('JobPreviousPath', location.previousPath);
            }
        } catch (error) {
            console.log('No previous data found', error);
        }
    }, [location]);

    let checkisMobile = ScreenWidth < 560;
    const dataReload = () => {
        setState((state) => ({ ...state, refresherFlag: new Date() }));
    };

    const closetModal = (res) => {
        setState((st) => ({
            ...st,
            show: false,
            showCustomerModal: false,
            showDepotModal: false,
            showAddInspection: false,
            showEditInspection: false,
            selectedInspection: null
        }));
        res && props.pullJobDetail();
    };
    useEffect(() => {
        setJobDetails(props.jobDetails);
        // setState((st) => ({ ...st, showModal: props?.jobDetails?.customerIsOnStop }));
    }, [props.jobDetails]);
    useEffect(() => {
        setState((st) => ({ ...st, showModal: props?.jobDetails?.customerIsOnStop || false }));
    }, [props.jobDetails.customerIsOnStop]);

    const handleInspectionModal = (m) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.selectedInspection = m;
            newSt.showAddInspection = m?.displayAddInspectionCheck === 'Y' ? true : false;
            newSt.showEditInspection = m?.displayEditInspectionCheck === 'Y' ? true : false;
            return newSt;
        });
    };

    // useEffect(async () => {
    //     if (props.jobDetails?.jobID && props.showDoc) {
    //         let res = await getJobRequiredDocuments(props.jobDetails?.jobID);
    //         setJobDocument((state) => ({ ...state, list: res.data.list }));
    //     }
    // }, [props.jobDetails?.jobID]);

    // const getMakeModel =
    //     jobDetails?.vehicleMake || jobDetails?.vehicleModel
    //         ? ` ${jobDetails?.vehicleMake ? jobDetails?.vehicleMake : ''} ${jobDetails?.vehicleModel ? jobDetails?.vehicleModel : ''}`
    //         : '';
    const handleEditRegClick = (val) => {
        history.push({
            pathname: `/controller/editVehicle/${jobDetails?.jobVehicleID}`,
            search: ''
        });
    };
    const handleShowDetails = (val) => {
        setState({ [val]: true });
    };
    return (
        <div>
            {/* <StickyNotes frompage="Customers" customerID={jobDetails?.customerID} bgColor="#ffcf89" />
            <StickyNotes frompage="Depots" depotID={jobDetails?.jobDepotID} bgColor="#ffcf89" />
            <StickyNotes frompage="Vehicle" NoteVehicleID={jobDetails?.jobVehicleID} bgColor="#ffcf89" /> */}
            {/* <AllStickyNotes
                frompage="Jobs"
                jobID={props?.scheduleJobID}
                customerID={jobDetails?.customerID}
                depotID={jobDetails?.jobDepotID}
                NoteVehicleID={jobDetails?.jobVehicleID}
                isRefresh={jobDetails?.newDate}
            // variant="filled"
            /> */}
            <Grid container>
                <Grid item xs={12} style={{ paddingTop: '5px' }}>
                    {jobDetails?.customerCreditAccountMessage && (
                        <Alert variant="filled" severity="error" style={{ padding: 7 }}>
                            {jobDetails?.customerCreditAccountMessage}
                        </Alert>
                    )}
                </Grid>
                <Grid item xs={12} style={{ paddingTop: '5px' }}>
                    {jobDetails?.customerIsOnStop && (
                        <Alert variant="filled" severity="error" style={{ padding: 7 }}>
                            The customer - {jobDetails?.customerName} is on stop
                        </Alert>
                    )}
                </Grid>
            </Grid>
            <Grid container style={{ gap: 6 }} spacing={0} alignItems="flex-start" className="mt_10">
                <Grid item xs={12} lg={12}>
                    <Grid item container xs={12} justify="flex-start" style={{ backgroundColor: '#f5f9f9', padding: '0 5px' }}>
                        {jobDetails?.jobOrderNo ? (
                            <Grid xs={12} sm={12} md={4} lg={4} xl>
                                <FormHelperText shrink>Order number</FormHelperText>
                                <Typography variant="button" className={classes.fontValueSizer}>
                                    {jobDetails?.jobOrderNo || ''}({jobDetails?.jobAgentOrderNo})
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid xs={7} sm={4} md={4} lg={2} xl>
                                <FormHelperText shrink>Job Reference</FormHelperText>
                                <Typography variant="button" className={classes.fontValueSizer}>
                                    {jobDetails?.jobAgentOrderNo || ''}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={5} sm={2} md={3} lg={1} xl>
                            <FormHelperText shrink>Order Date</FormHelperText>
                            <Typography variant="button" className={classes.fontValueSizer}>
                                {jobDetails?.jobBookingDate}
                            </Typography>
                        </Grid>
                        <Grid item xs={7} sm={6} md={5} lg={2} xl={2}>
                            <FormHelperText shrink>Customer</FormHelperText>
                            <Typography variant="button" className={classes.fontValueSizer}>
                                <span onClick={() => handleShowDetails('showCustomerModal')} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                                    {jobDetails?.customerName}
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item xs={5} sm={4} md={4} lg={2} xl>
                            <FormHelperText shrink>Depot</FormHelperText>
                            <Typography variant="button" className={classes.fontValueSizer}>
                                <span onClick={() => handleShowDetails('showDepotModal')} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                                    {jobDetails?.depotName}
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item xs={7} sm={2} md={3} lg xl>
                            <FormHelperText shrink>Reg No</FormHelperText>
                            <Typography variant="button" className={classes.fontValueSizer}>
                                <span onClick={handleEditRegClick} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                                    {jobDetails?.jobRegNumber}
                                </span>
                                {/* &nbsp;({getMakeModel.trim()}) */}
                            </Typography>
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                            <FormHelperText shrink>Job Status</FormHelperText>
                            <Typography variant="button" className={classes.fontValueSizer}>{jobDetails?.vehicleJobStatus}</Typography>
                        </Grid> */}
                        <Grid item xs={5} sm={'auto'} lg xl>
                            <FormHelperText shrink>Job Priority</FormHelperText>
                            <Typography variant="button" className={classes.fontValueSizer}>
                                {jobDetails?.jobTypeDescription}
                            </Typography>
                        </Grid>
                        <Grid item xs={7} sm={'auto'} lg xl={1} style={{ marginLeft: ScreenWidth > 450 ? '10px' : '' }}>
                            <div style={{ width: '100%', textAlign: ScreenWidth > 450 ? 'end' : 'left' }}>
                                <FormHelperText style={{ textAlign: ScreenWidth > 450 ? 'end' : 'left' }}>Chargeable </FormHelperText>
                                <Typography align="right" variant="button" className={classes.fontValueSizer} style={{ fontWeight: 'bold', color: 'black' }}>
                                    {/* £{jobDetails?.jobCustomerOrderTotal?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} */}
                                    {formatters.CurrencyNumberWithPound(jobDetails?.chargeable)}
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={5} sm={'auto'} lg xl style={{ marginLeft: ScreenWidth > 450 ? '10px' : '' }}>
                            <div style={{ width: '100%', textAlign: ScreenWidth > 450 ? 'end' : 'left' }}>
                                <FormHelperText style={{ textAlign: ScreenWidth > 450 ? 'end' : 'left' }}>Non Chargeable </FormHelperText>
                                <Typography variant="button" className={classes.fontValueSizer} style={{ fontWeight: 'bold', color: 'black' }}>
                                    {formatters.CurrencyNumberWithPound(jobDetails.nonChargable)}
                                </Typography>
                            </div>
                        </Grid>
                        {/* <Grid item xs={6} sm={3}>
                            <FormHelperText shrink>Reg Number</FormHelperText>
                            <Typography variant="button">{jobDetails?.jobRegNumber}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <FormHelperText shrink>Make</FormHelperText>
                            <Typography variant="button">{jobDetails?.vehicleMake}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <FormHelperText shrink>Model</FormHelperText>
                            <Typography variant="button">{jobDetails?.vehicleModel}</Typography>
                        </Grid> */}
                    </Grid>
                </Grid>
                {/* <Grid item xs={12} style={{ marginTop: 3 }}>
                    <Alert icon={<InfoIcon fontSize="inherit" />} severity="warning" className="alert-items">
                        {jobDetails?.jobDescription}
                    </Alert>
                </Grid> */}
                <Grid item xs={12}>
                    <JobCustomizeStepper VehicleID={jobDetails?.jobVehicleID} jobDetails={jobDetails} pullJobDetail={props.pullJobDetail} />
                </Grid>
                {props.showDoc && (
                    <>
                        {listWithDocs.map(({ item: m, matchingDoc }, i) => {
                            const showInspection = m.displayAddInspectionCheck === 'Y' || m.displayEditInspectionCheck === 'Y';
                            return (
                                <React.Fragment key={`list-${i}`}>
                                    {showInspection && (
                                        <Grid item>
                                            <span style={{ position: 'relative', top: '0px', left: '0px' }}>
                                                <CustomButtonChip
                                                    label={m.docName}
                                                    title={m.docName}
                                                    icon={BuildIcon}
                                                    onClick={() => handleInspectionModal(m)}
                                                    backgroundColour={m.buttonBackground}
                                                    color={m.buttonText}
                                                    iconColor={m.buttonBackground}
                                                    iconBg={m.buttonText}
                                                    // width={163}
                                                />
                                            </span>
                                        </Grid>
                                    )}
                                    {matchingDoc && (
                                        <Grid item>
                                            <div>
                                                <span style={{ position: 'relative', top: '-9px', left: '0px' }}>
                                                    <FileUploaderButton
                                                        recordId={matchingDoc.scheduleDocID}
                                                        fileUploaderConfigName="ScheduleDocumentsRequired"
                                                        fileCount={matchingDoc.fileCount}
                                                        gridRelaod={dataReload}
                                                        docIDPassed={true}
                                                        isDash={true}
                                                        docName={matchingDoc.docName}
                                                        // width={163}
                                                        isPrevReload={props.pullJobDetail}
                                                    />
                                                </span>
                                            </div>
                                        </Grid>
                                    )}
                                </React.Fragment>
                            );
                        })}
                        {unmatchedDocs.map((d, i) => (
                            <Grid item key={`doc-${i}`}>
                                <div>
                                    <span style={{ position: 'relative', top: '-9px', left: '0px' }}>
                                        <FileUploaderButton
                                            recordId={d.scheduleDocID}
                                            fileUploaderConfigName="ScheduleDocumentsRequired"
                                            fileCount={d.fileCount}
                                            gridRelaod={dataReload}
                                            docIDPassed={true}
                                            isDash={true}
                                            docName={d.docName}
                                            // width={163}
                                            isPrevReload={props.pullJobDetail}
                                        />
                                    </span>
                                </div>
                            </Grid>
                        ))}
                    </>
                )}
                {jobDetails.offHireJobID && (
                    <Grid item>
                        <span style={{ position: 'relative', top: '-7px', left: '-3px', marginRight: '5px' }}>
                            <FileUploaderButton
                                recordId={jobDetails.offHireJobID}
                                fileUploaderConfigName="JobScreen"
                                fileCount={jobDetails.offhireFileCount}
                                gridRelaod={dataReload}
                                isDash={true}
                                style={{ height: checkisMobile ? 24 : 32, textAlign: 'left' }}
                                isPrevReload={props.pullJobDetail}
                                docName={'Offhire Photo/Upload'}
                            />
                        </span>
                    </Grid>
                )}

                {state.showModal ? (
                    <DialogComp title={`Warning`} maxWidth="md" onClose={() => setState((st) => ({ ...st, showModal: false }))} fullWidth>
                        <Alert severity="warning">Customer is on stop</Alert>
                        <br />
                    </DialogComp>
                ) : null}
            </Grid>
            {state.showCustomerModal ? (
                <DialogComp open={true} onClose={() => closetModal(false)} title={'Customer Details'} maxWidth="sm" fullWidth>
                    <CustomerDetails customerID={jobDetails.customerID} onFormSubmit={() => closetModal(false)} />
                </DialogComp>
            ) : null}
            {state.showDepotModal ? (
                <DialogComp open={true} onClose={() => closetModal(false)} title={'Depot Details'} maxWidth="sm" fullWidth>
                    <DepotDetails customerID={jobDetails.jobDepotID} onFormSubmit={() => closetModal(false)} />
                </DialogComp>
            ) : null}
            {state.showAddInspection && (
                <VehicleDailyChecks
                    sheduleVechicleID={jobDetails?.jobVehicleID}
                    sheduleID={state.selectedInspection?.scheduleID}
                    scheduleEventID={state.selectedInspection?.scheduleEventID}
                    onClose={closetModal}
                    displayCheck={state.selectedInspection?.displayCheck}
                    frompage={false}
                    checkID={state.selectedInspection?.vehicleInspectionID}
                />
            )}
            {state.showEditInspection && (
                <EditVehicleDailyChecks
                    checkID={state.selectedInspection?.vehicleInspectionID}
                    displayCheck={state.selectedInspection?.displayCheck}
                    onClose={closetModal}
                    frompage={false}
                />
            )}
        </div>
    );
};
export default JobDetail;
